import React from 'react';
import { Company } from '../../../../../types/company';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { Collapsable } from '../../../Collapsable';
import { FeatureToggleItem, FeatureToggleTitle, FeatureToggleExplanation } from '../common';

interface ProductFeatureTogglesViewProps {
  company: Company;
  update: (company: Company) => Promise<void>;
}

export default function ProductFeatureTogglesView({ company, update }: ProductFeatureTogglesViewProps) {
  const copy = new Company(company);
  const toggles = copy.settings.featureToggles.products;

  return (
    <Collapsable
      open={toggles.products}
      header={
        <FeatureToggleItem value={toggles.products} onChange={async v => {}}>
          <FeatureToggleTitle text={t(TranslationKey.productsProductFeatureToggleTitle).singular.upper} />
        </FeatureToggleItem>
      }
    >
      <FeatureToggleItem
        indent={1}
        value={toggles.displayEmptyStock}
        onChange={async value => await update(copy.withProductsDisplayEmptyStockFeatureToggle(value))}
      >
        <FeatureToggleTitle text={t(TranslationKey.productsDisplayEmptyStockFeatureToggleTitle).singular.upper} />
        <FeatureToggleExplanation
          text={t(TranslationKey.productsDisplayEmptyStockFeatureToggleExplanation).singular.upper}
        />
      </FeatureToggleItem>
    </Collapsable>
  );
}
